import {
  Alert,
  AlertTitle,
  Box,
  CircularProgress,
  Grid,
  Link,
  MenuItem,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect } from 'react';

import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { yupResolver } from '@hookform/resolvers/yup';

import { useGA4React } from 'ga-4-react';
import moment from 'moment-business-days';
import * as yup from 'yup';
import PrimaryButton from '../ui/buttons/primaryButton';
import Checkbox from '../ui/forms/fields/checkbox';
import CurrencyInput from '../ui/forms/fields/currencyInput';
import GreatDatePicker from '../ui/forms/fields/datePicker';
import Select from '../ui/forms/fields/select';

import { objectToArray } from '../../libs/helpers';
import SaveProcess from '../dialogs/saveProcess';
import { Report } from '../../libs/loggers';

function RegularWithdrawalsDetails({
  extendedForm,
  data,
  submitionData,
  onNext,
  onBack,
  stepSlug,
  openSave,
  onSaveAndExit,
}) {
  let ga4React = useGA4React();

  const loading = useSelector((state) => state.submition.submition?.loading);
  const userId = useSelector((state) => state.submition.data?.userId);
  const page = window.location.pathname.replace(/^\/|\/$/g, '');
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const submitionId = useSelector((state) => state.submition.submition?.submitionId);
  const formStepper = useSelector((state) => state.formStepper.value);

  const RegularWithdrawalsDetailsFormValidationSchema = (data, extendedForm) => {
    const validationSchema = yup.object().shape({
      stepSlug: yup.string().required(),
      regularWithdrawalPaymentFrequency: yup
        .string()
        .default('None')
        .test('vehicleCheck', 'Please select regular withdrawal option.', function (val) {
          let isValid = false;

          if (data.vehicle !== 'Retirement Annuity') {
            if (val) isValid = true;
          } else {
            isValid = true;
          }
          return isValid;
        }),

      regularWithdrawalsFirstPmnt: yup
        .string()
        .nullable()
        .when('regularWithdrawalPaymentFrequency', {
          is: (regularWithdrawalPaymentFrequency) => regularWithdrawalPaymentFrequency !== 'None',
          then: (schema) => schema.required('Please select a regular withdrawal date.'),
          otherwise: (schema) => schema,
        }),

      regularWithdrawalsFund1: yup.string().when('regularWithdrawalPaymentFrequency', {
        is: (regularWithdrawalPaymentFrequency) => regularWithdrawalPaymentFrequency !== 'None',
        then: yup.string().required('Please select at least one fund for your regular withdrawal.'),
        otherwise: yup.string(),
      }),
      regularWithdrawalsFund1Amount: yup.number().when('regularWithdrawalPaymentFrequency', {
        is: (regularWithdrawalPaymentFrequency) => regularWithdrawalPaymentFrequency !== 'None',
        then: yup
          .number()
          .typeError('Please enter a regular withdrawal amount.')
          .moreThan(0, 'This amount can not be R0')
          .required('Please enter a amount.'),
        otherwise: yup.number('Must be a number.'),
      }),
      regularWithdrawalsFund2: yup.string(),
      regularWithdrawalsFund2Amount: yup.number('Must be a number.').typeError(''),

      regWithdrawalFundWarning: yup
        .bool()
        .test(
          'checkWithdrawalWarning',
          'Please confirm that you have read the withdrawal fund notice.',
          function (val) {
            let isValid = false;
            let fundsHasWithdraw =
              data.funds.filter(
                (fund) =>
                  this.parent.regularWithdrawalPaymentFrequency !== 'None' &&
                  fund.fund.withdrawWarning &&
                  (this.parent.regularWithdrawalsFund1 === fund.fund.name ||
                    this.parent.regularWithdrawalsFund2 === fund.fund.name)
              ).length !== 0;

            if (fundsHasWithdraw) {
              if (val) isValid = true;
            } else {
              isValid = true;
            }
            return isValid;
          }
        ),

      regWithdrawalFundDebitOrderWarning: yup
        .bool()
        .test(
          'checkDebitOrder',
          'Please confirm that you have read the withdrawal fund debit order notice.',
          function (val) {
            let isValid = false;
            let fundsHasDebitOrder =
              data.funds.filter(
                (fund) =>
                  this.parent.regularWithdrawalPaymentFrequency !== 'None' &&
                  fund.monthly &&
                  (this.parent.regularWithdrawalsFund1 === fund.fund.name ||
                    this.parent.regularWithdrawalsFund2 === fund.fund.name)
              ).length !== 0;

            if (fundsHasDebitOrder) {
              if (val) isValid = true;
            } else {
              isValid = true;
            }
            return isValid;
          }
        ),
    });

    return validationSchema;
  };

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
    watch,
    setValue,
    getValues,
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(RegularWithdrawalsDetailsFormValidationSchema(data, extendedForm)),
  });

  useEffect(() => {
    setValue('stepSlug', stepSlug, { shouldValidate: true });
  }, [stepSlug, setValue]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (submitionData) {
      Object.entries(submitionData).forEach(([key, value]) => {
        setValue(key, value, { validate: true });
      });
    }
  }, [submitionData]);

  useEffect(() => {
    const eventInfo = {
      action: 'view',
      category: 'step4_formstep_view',
      description: 'viewed a form step in step 4',
      value: {
        currentPage: page,
        stepSlug,
        activeFormStep: formStepper?.step,
      },
    };

    Report(eventInfo, userId, submitionId);
  }, []);
  const NavButtons = (props) => (
    <>
      <Box display="flex" justifyContent={'flex-end'}>
        <PrimaryButton disabled={props.isFirstStep} onClick={() => onBack()} sx={{ mt: 1, mr: 1 }}>
          Back
        </PrimaryButton>
        <PrimaryButton
          onClick={() => handleNext()}
          disabled={loading}
          sx={{
            mt: 1,
            mr: 1,
            '&.Mui-disabled': {
              background: '#CC6323',
              color: '#fff',
            },
          }}
        >
          {userId ? 'Save & Continue' : 'Continue'}{' '}
          {loading && <CircularProgress sx={{ ml: 1 }} size={isMobile ? 15 : 20} color="inherit" />}
        </PrimaryButton>
        <PrimaryButton variant="outlined" onClick={() => handleSaveAndExit(userId)} sx={{ mt: 1 }}>
          {'Save & Exit'}
        </PrimaryButton>
      </Box>
      {!userId && (
        <Box display="flex" justifyContent={'flex-end'} marginTop={1}>
          <Typography variant="body1">
            {' '}
            Your progress is not being saved. Click{' '}
            <Link
              sx={{ cursor: 'pointer' }}
              variant="body1"
              underline="always"
              onClick={() => {
                handleOpenSave();
              }}
            >
              here
            </Link>{' '}
            to save.
          </Typography>
        </Box>
      )}
    </>
  );

  const handleNext = async () => {
    ga4React.event('complete_form_step', `${stepSlug}`, 'investement_submition');
    setValue('completeProcess', false, { shouldValidate: true });
    handleSubmit(onSubmit)();
  };

  const handleSaveAndExit = (userId) => {
    const data = getValues();
    const newSubmition = { ...submitionData, ...data };
    onSaveAndExit(newSubmition, userId);
  };

  const handleOpenSave = () => {
    const data = getValues();
    const newSubmition = { ...submitionData, ...data };
    openSave(newSubmition);
  };

  const onSubmit = (data) => {
    const newSubmition = { ...submitionData, ...data };
    onNext(newSubmition);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Typography sx={{ ml: 1 }}>
          Please only complete this section if you would like to receive a regular withdrawal from
          your investment. Regular withdrawals can be cancelled/amended at any time.
        </Typography>
        <Grid item xs={12} md={6}>
          <Select
            name="regularWithdrawalPaymentFrequency"
            label="Payment Frequency"
            control={control}
            error={!!errors.regularWithdrawalPaymentFrequency}
            defaultValue={'None'}
          >
            <MenuItem value="None">I do not require a regular withdrawal</MenuItem>
            <MenuItem value="Monthly">Monthly</MenuItem>
            <MenuItem value="Quarterly">Quarterly</MenuItem>
            <MenuItem value="Biannually">Biannually</MenuItem>
            <MenuItem value="Annually">Annually</MenuItem>
          </Select>
        </Grid>
      </Grid>

      {watch('regularWithdrawalPaymentFrequency') !== 'None' && (
        <>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <GreatDatePicker
                name="regularWithdrawalsFirstPmnt"
                control={control}
                label="Withdrawal Commencement Date"
                minDate={moment().add(1, 'month').startOf('month')}
                maxDate={moment().add(2, 'years')}
                views={['year', 'month']}
                inputFormat="MMMM YYYY"
                error={!!errors.regularWithdrawalsFirstPmnt}
              />
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Select
                name="regularWithdrawalsFund1"
                label="Fund"
                control={control}
                error={!!errors.regularWithdrawalsFund1}
                helperText={errors.regularWithdrawalsFund1?.message}
              >
                <MenuItem value={''}>{'None'}</MenuItem>
                {data.funds &&
                  data.funds
                    .filter((fund) => fund.fund.formSlug !== 'proton_hf_investor_application')
                    .map((fund, index) => (
                      <MenuItem value={fund.fund.name} key={index}>
                        {fund.fund.name}
                      </MenuItem>
                    ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
              <CurrencyInput
                type="number"
                id="regularWithdrawalsFund1Amount"
                label="Amount"
                symbol="R"
                error={!!errors.regularWithdrawalsFund1Amount}
                helperText={errors?.regularWithdrawalsFund1Amount?.message}
                control={control}
                defaultValue={0}
                name="regularWithdrawalsFund1Amount"
              />
            </Grid>

            {watch('regularWithdrawalsFund1') && (
              <>
                <Grid item xs={12} md={6}>
                  <Select
                    name="regularWithdrawalsFund2"
                    label="Fund"
                    control={control}
                    error={!!errors.regularWithdrawalsFund2}
                  >
                    <MenuItem value={''}>{'None'}</MenuItem>
                    {data.funds &&
                      data.funds
                        .filter((fund) => fund.fund.formSlug !== 'proton_hf_investor_application')
                        .map((fund, index) => (
                          <MenuItem value={fund.fund.name} key={index}>
                            {fund.fund.name}
                          </MenuItem>
                        ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={6}>
                  <CurrencyInput
                    type="number"
                    id="regularWithdrawalsFund2Amount"
                    label="Amount"
                    symbol="R"
                    error={!!errors.regularWithdrawalsFund2Amount}
                    helperText={errors?.regularWithdrawalsFund2Amount?.message}
                    control={control}
                    defaultValue={0}
                    name="regularWithdrawalsFund2Amount"
                  />
                </Grid>
              </>
            )}
          </Grid>

          {(watch('regularWithdrawalsFund1') || watch('regularWithdrawalsFund2')) &&
            data.funds.filter(
              (fund) =>
                fund.monthly &&
                (watch('regularWithdrawalsFund1') === fund.fund.name ||
                  watch('regularWithdrawalsFund2') === fund.fund.name)
            ).length !== 0 && (
              <Alert
                severity={errors.regWithdrawalFundDebitOrderWarning ? 'error' : 'warning'}
                sx={{ m: 2 }}
              >
                <AlertTitle>Debit Order with Regular Withdrawal Warning.</AlertTitle>
                Based on your current request, you will be both contributing to and withdrawing from
                the same fund each month/term. Please indicate that this is in fact what you want to
                do. Alternatively, please make an amendment to your instruction.
                <br />
                <Checkbox
                  name={'regWithdrawalFundDebitOrderWarning'}
                  label="I understand and want to proceed."
                  control={control}
                  color={errors.regWithdrawalFundDebitOrderWarning ? 'error' : 'warning'}
                />
              </Alert>
            )}

          {(watch('regularWithdrawalsFund1') || watch('regularWithdrawalsFund2')) &&
            data.funds.filter(
              (fund) =>
                fund.fund.withdrawWarning &&
                (watch('regularWithdrawalsFund1') === fund.fund.name ||
                  watch('regularWithdrawalsFund2') === fund.fund.name)
            ).length !== 0 && (
              <Alert severity={errors.regWithdrawalFundWarning ? 'error' : 'warning'} sx={{ m: 2 }}>
                <AlertTitle>Avoid the premature eroding of your capital.</AlertTitle>
                Regular withdrawals have a large impact on investment growth. Selecting the correct
                fund and drawdown amount is key:
                <lu>
                  <li>
                    Withdrawing at a rate higher than the growth of your investment can negatively
                    impact growth.
                  </li>
                  <li>
                    Investment funds with more aggressive risk profiles typically should stay
                    invested for longer time horizons.
                  </li>
                  <li>
                    Investment funds with more conservative risk profiles are likely to cater better
                    for regular withdrawals as they tend to exhibit less volatility, reducing the
                    investor’s risk to withdraw during a market downturn and realizing a loss.
                  </li>
                </lu>
                <Checkbox
                  name={'regWithdrawalFundWarning'}
                  label="I understand and want to proceed."
                  control={control}
                  color={errors.regWithdrawalFundWarning ? 'error' : 'warning'}
                />
              </Alert>
            )}
        </>
      )}
      <Grid item xs={12} md={12}>
        <NavButtons isLastStep={false} isFirstStep={false} index={0} />
      </Grid>
      <Box display={'inlineBlock'}>
        {objectToArray(errors).map((error, index) => (
          <Typography color={'error'} key={index}>
            {error.value.message}
          </Typography>
        ))}
      </Box>
    </>
  );
}

export default RegularWithdrawalsDetails;
